import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ModalComponent } from '../shared/modal/modal.component';

@Component({
  selector: 'atp-sign-accepted-dialog',
  standalone: true,
  imports: [CommonModule, RouterLink, ModalComponent],
  templateUrl: './atp-sign-accepted-dialog.component.html',
  styleUrl: './atp-sign-accepted-dialog.component.scss',
})
export class AtpSignAcceptedDialogComponent {
  @Input() active: boolean = false;
  @Input() documents: any = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() modalHeaderTitle: string = '';
  @Input() modalBody: string = '';
  @Input() projectId: any = '';
  @Input() dashboard: boolean = false;
  @Input() siteVisits: { id: string; siteNumber: number; propertyName: string }[] = [];

  @Output() modalClosed = new EventEmitter<boolean>();

  /** Title Case per the CONNECT 2.0 button convention. */
  get scheduleSiteVisitsLabel(): string {
    return this.siteVisits.length > 1 ? 'Schedule Site Visits' : 'Schedule Site Visit';
  }

  /** Sentence case, appended to `modalBody` — the existing sentence is left intact. */
  get siteVisitOfferSentence(): string {
    if (this.siteVisits.length === 0) {
      return '';
    }
    return this.siteVisits.length > 1
      ? ` ${this.siteVisits.length} site visits are ready to schedule.`
      : ' Your site visit is ready to schedule.';
  }

  get scheduleSiteVisitsQueryParams(): { visitId: string } {
    return { visitId: this.siteVisits.map((siteVisit) => siteVisit.id).join(',') };
  }

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.closeDialog();
  }
}
